const DEALLENS_ID_TOKEN_PATTERN = /^[A-Za-z0-9_-]+$/;

/**
 * Primary list-row id: prefers `id`, then `deallens_id` (matches DeallensStore swipe tracking).
 *
 * @param {object | null | undefined} d
 * @returns {string}
 */
export function rowDealId(d) {
  return String(d?.id ?? d?.deallens_id ?? "").trim();
}

/**
 * Alias keys for the same deal row — covers `deallens#` prefix and split id/deallens_id fields.
 *
 * @param {object | null | undefined} deal
 * @returns {string[]}
 */
export function swipeFlightKeys(deal) {
  const keys = new Set();
  const add = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return;
    keys.add(v);
    const stripped = stripDeallensIdPrefix(v);
    if (stripped) keys.add(stripped);
  };
  add(rowDealId(deal));
  add(deal?.id);
  add(deal?.deallens_id);
  add(deal?.metadata?.previous_deallens_id);
  return [...keys];
}

/**
 * @param {string} token - Id token after `deallens#` strip
 * @returns {boolean}
 */
export function validateDeallensIdToken(token) {
  const trimmed = String(token ?? "").trim();
  return Boolean(trimmed) && DEALLENS_ID_TOKEN_PATTERN.test(trimmed);
}

/**
 * @param {string} rawId
 * @returns {string}
 */
export function stripDeallensIdPrefix(rawId) {
  return String(rawId ?? "")
    .trim()
    .replace(/^deallens#/i, "")
    .trim();
}

/**
 * Resolves a URL-safe DealLens id token from a deal row.
 * Prefers deallens_id over id; optimistic rows fall back to previous_deallens_id.
 *
 * @param {object | null | undefined} deallens
 * @returns {string}
 */
export function resolveDeallensUrlId(deallens) {
  const primary = String(deallens?.deallens_id ?? deallens?.id ?? "").trim();
  const candidates = [primary];
  if (/^optimistic:/i.test(primary)) {
    candidates.push(String(deallens?.metadata?.previous_deallens_id ?? "").trim());
  }
  for (const raw of candidates) {
    const token = stripDeallensIdPrefix(raw);
    if (validateDeallensIdToken(token)) return token;
  }
  return "";
}
